import { BasePalette, Palette } from '../general/color-palette';
import { Theme } from '../general/theme';
import { TextDirection } from '../general/text-direction';

const black: BasePalette = {
  100: '#000000', // Black
  400: '#787B80', // Gray
  450: '#6E6E6E', // Rock
  500: '#ADAEB2', // Bombay
  600: '#C4C4C4', // Silver
  650: '#CCCCCC', // Singa Postal
  700: '#ECECEE', // Athens Gray
  800: '#F7F7F7', // Cultured
  850: '#F0F0F0', // White Smoke
  900: '#FFFFFF', // White
};

const blue: Palette = {
  200: '#0074E8', // Carolina Blue
  300: '#4CC9F9', // Malibu
};

const beige: Palette = {
  300: '#787B80', // Gray Web
};

const validation: Palette = {
  350: '#D51121', // Fire Engine Red
  200: '#32AA78', // Medium Sea Green
  400: '#CB1A2A',
};

export const peugeotTheme: Theme = {
  currentDirection: 'ltr',
  color: {
    base: black,
    primary: blue,
    secondary: beige,
    accent: validation,
  },
  font: {
    normal: 'PeugeotNormal, GeSsText, Arial',
    primary: 'PeugeotLight, GeSsText, Arial',
    secondary: 'PeugeotBold, GeSsText, Arial',
    accent: 'PeugeotBold, GeSsTwo, Arial',
  },
  fontSize: {
    small: 13,
    normal: 16,
    big: 20,
    large: 28,
    extraLarge: 36,
    huge: 60,
  },
  breakPoint: {
    mobile: 450,
    tablet: 960,
    smallDesktop: 1280,
  },
  get direction() {
    return this.currentDirection;
  },
  set direction(direction: TextDirection) {
    this.currentDirection = direction;
  },
};
